import { queryOptions } from "@tanstack/react-query";
const fulfillmentConfiguration = {
  keys: {
    root: () => ["fulfillmentConfiguration"]
  },
  // Query options for reading entity configuration
  readEntity: (params) => queryOptions({
    queryKey: [
      ...fulfillmentConfiguration.keys.root(),
      "entity",
      { params }
    ],
    queryFn: async () => {
      const { readEntityConfiguration } = await import("../api/fulfillment-configuration/rpc.js");
      return readEntityConfiguration(params);
    }
  }),
  // Mutation options for upserting entity configuration
  upsertEntity: () => ({
    mutationKey: [...fulfillmentConfiguration.keys.root(), "upsertEntity"],
    mutationFn: async (params) => {
      const { upsertEntityConfiguration } = await import("../api/fulfillment-configuration/rpc.js");
      return upsertEntityConfiguration(params);
    }
  })
};
export {
  fulfillmentConfiguration
};
//# sourceMappingURL=fulfillment-configuration.js.map
